// src/app/public-home/publicHome.constants.ts

import type {
  AccessRequestFormValues,
  AccessRole,
} from "./publicHome.types";

export const INITIAL_ACCESS_REQUEST_VALUES:
AccessRequestFormValues = {
  name:
    "",

  email:
    "",

  role:
    "",

  looksAfter:
    "",
};

export const ACCESS_ROLE_OPTIONS:
readonly {
  value:
    AccessRole;

  label:
    string;
}[] = [
  {
    value:
      "property_manager",

    label:
      "Property manager",
  },
  {
    value:
      "self_managed_owner",

    label:
      "Self-managed owner",
  },
  {
    value:
      "tradesperson",

    label:
      "Tradesperson",
  },
] as const;